import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/query/react";
import { userManagementBaseUrl, userManagement } from "../endpoints";

export const openingBalanceKarmaService = createApi({
  reducerPath: "openingBalanceKarmaService",
  baseQuery: fetchBaseQuery({ baseUrl: userManagementBaseUrl }),
  tagTypes: ["openingBalanceKarma"],
  endpoints: (builder) => ({
    getAllOpeningBalanceKarma: builder.mutation({
      query: (body) => ({
        url: `${userManagement.openingBalanceKarmaController.getAllOpeningBalanceKarma}/${body.payload.page}/${body.payload.size}?orderBy=${body.payload.orderBy}`,
        method: "GET",
        headers: { Authorization: `Bearer ${body.token}` },
      }),
    }),
    searchOpeningBalanceKarma: builder.mutation({
      query: (body) => ({
        url: `${userManagement.openingBalanceKarmaController.searchOpeningBalanceKarma}`,
        method: "POST",
        body: body.payload,
        headers: { Authorization: `Bearer ${body.token}` },
      }),
    }),
    saveOpeningBalanceKarma: builder.mutation({
      query: (body) => ({
        url: `${userManagement.openingBalanceKarmaController.saveOpeningBalanceKarma}`,
        method: "POST",
        body: body.payload,
        headers: { Authorization: `Bearer ${body.token}` },
      }),
    }),
    updateOpeningBalanceKarma: builder.mutation({
      query: (body) => ({
        url: `${userManagement.openingBalanceKarmaController.updateOpeningBalanceKarma}/${body.id}`,
        method: "PUT",
        body: body.payload,
        headers: { Authorization: `Bearer ${body.token}` },
      }),
    }),
    deleteOpeningBalanceKarma: builder.mutation({
      query: (body) => ({
        url: `${userManagement.openingBalanceKarmaController.deleteOpeningBalanceKarma}/${body.id}`,
        method: "DELETE",
        headers: { Authorization: `Bearer ${body.token}` },
      }),
    }),
    getOpeningBalanceKarmaById: builder.mutation({
      query: (body) => ({
        url: `${userManagement.openingBalanceKarmaController.getOpeningBalanceKarmaById}/${body.id}`,
        method: "GET",
        headers: { Authorization: `Bearer ${body.token}` },
      }),
    }),
    getAllOpeningBalanceKarmaList: builder.mutation({
      query: (body) => ({
        url: `${userManagement.openingBalanceKarmaController.getAllOpeningBalanceKarmaList}`,
        method: "GET",
        headers: { Authorization: `Bearer ${body.token}` },
      }),
    }),
    uploadBulkOpeningBalanceKarma: builder.mutation({
      query: (body) => ({
        url: `${userManagement.openingBalanceKarmaController.uploadBulkOpeningBalanceKarma}`,
        method: "POST",
        body: body.payload,
        headers: { Authorization: `Bearer ${body.token}` },
      }),
    }),
  }),
});

export const {
  useGetAllOpeningBalanceKarmaMutation,
  useSearchOpeningBalanceKarmaMutation,
  useSaveOpeningBalanceKarmaMutation,
  useUpdateOpeningBalanceKarmaMutation,
  useDeleteOpeningBalanceKarmaMutation,
  useGetOpeningBalanceKarmaByIdMutation,
  useGetAllOpeningBalanceKarmaListMutation,
  useUploadBulkOpeningBalanceKarmaMutation,
} = openingBalanceKarmaService;
